import { render, staticRenderFns } from "./CliffordView.vue?vue&type=template&id=6df991a4&scoped=true&"
import script from "./CliffordView.vue?vue&type=script&lang=js&"
export * from "./CliffordView.vue?vue&type=script&lang=js&"
import style0 from "./CliffordView.vue?vue&type=style&index=0&id=6df991a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df991a4",
  null
  
)

export default component.exports